import { ObjectsViewType } from "@organisms/ObjectsView/ObjectsView.types"

export default function getObjectsViewLabel(viewType: ObjectsViewType): string | undefined {
    if (viewType === "table") {
        return "Table"
    } else if (viewType === "cards") {
        return "Cards"
    } else if (viewType === "timeline") {
        return "Timeline"
    } else {
        return undefined
    }
}
